<div class="playerContainer"
            [ngClass]="{'playerContainer--red': data.id === 1,
                        'playerContainer--blue': data.id === 2,
                        'playing': data.status}">
  <div class="playerContainer__avatar">
    <img src="../../assets/avatar-{{data.img}}.png" alt="photo_player">
  </div>
  <div class="playerContainer__info">
    <h1>{{data.userName}}</h1>
    <h2>Puntos: {{data.points}}</h2>
    <div>
      <p *ngIf="data.status">Jugando...</p>
    </div>
  </div>
</div>
